import { Injectable } from '@angular/core';
import {AuthenticationService} from './authentication.service';
import {UtileriasService} from './utilerias.service';
import {Controles} from '../constants/controles';

@Injectable({
  providedIn: 'root'
})
export class PermissionManagerService {

  constructor(
    public authenticationService: AuthenticationService,
    private utileriasService: UtileriasService) { }


  isGranted(control: Controles) {
    if (control === undefined) { // Cuando no se ha especificado ningún control, para que por default regresa FALSE
      return false;
    }
    const userData = sessionStorage.getItem('userData');
    if (userData !== null) {
      const permisos = this.utileriasService.decrypt(userData)
        .replace('[', '')
        .replace(']', '')
        .split(',');
      return permisos.find(element => element === control.toString()) ? true : false;
    } else {
      return false;
    }

  }
}
